var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const cell = css `
  padding: ${theme.spacing.x3};
`;
const hover = css `
  @media (hover: hover) {
    opacity: 0;
    ${styleUtils.transition('opacity')}

    tr:hover > & {
      opacity: 1;
    }
  }
`;
const defaultProps = {
    className: '',
    showOnHover: false,
};
const TableCell = (_a) => {
    var { children, className = defaultProps.className, showOnHover = defaultProps.showOnHover } = _a, restProps = __rest(_a, ["children", "className", "showOnHover"]);
    return (_jsx("td", Object.assign({ className: className, css: [
            cell,
            showOnHover && hover,
        ] }, restProps, { children: children })));
};
const MemoizedTableCell = memo(TableCell);
export { MemoizedTableCell as TableCell };
// MC-1068 Temporary hack for Storybook.
export default TableCell;
